import { api } from './apiClient';

const unwrapError = (error, fallback) => {
  if (error.response) {
    const data = error.response.data;
    if (Array.isArray(data?.errors)) return data.errors.join(', ');
    return data?.message || `Server error: ${error.response.status}`;
  }
  if (error.request) return 'Unable to reach the server. Please check your internet connection or try again later.';
  return error.message || fallback;
};

export const fetchFeaturedCardList = async (page = 1, pageSize = 50, searchtext = '') => {
  try {
    const response = await api.post('/api/v1/admin/featured-cards/list', {
      pagination: { page, pageSize },
      searchtext: searchtext || '',
    });
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to load featured cards'));
  }
};

export const createFeaturedCard = async (payload) => {
  try {
    const response = await api.post('/api/v1/admin/featured-cards', payload);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to create featured card'));
  }
};

export const updateFeaturedCard = async (payload) => {
  try {
    const response = await api.put('/api/v1/admin/featured-cards', payload);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to update featured card'));
  }
};

export const deactivateFeaturedCard = async (id) => {
  try {
    const response = await api.delete(`/api/v1/admin/featured-cards/${id}`);
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to deactivate featured card'));
  }
};

export const reorderFeaturedCards = async (cards) => {
  try {
    const response = await api.post('/api/v1/admin/featured-cards/reorder', { cards });
    return response.data;
  } catch (error) {
    throw new Error(unwrapError(error, 'Failed to reorder featured cards'));
  }
};

export const getAdminLesson = async (lessonId) => {
  const response = await api.get(`/api/v1/admin/lessons/${lessonId}`);
  return response.data;
};

export const getAdminChapter = async (chapterId) => {
  const response = await api.get(`/api/v1/admin/chapters/${chapterId}`);
  return response.data;
};
